import React from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore, userInfoStore } from '@pascal/pascal-core';
import { notificationStore } from '@pascal/pascal-core/shared/core/store';
import { BetResponseCode } from '@pascal/pascal-core/shared/core/enums/ResponseCodes';
import buttonClose from '../../../assets/images/catch-me/RDimg-close.png';

const QuickActionPopOver = observer(
  ({
    data,
    itemId,
    settingRef,
    isBetAmount,
    isAutoCashOut,
    handleCancelAction,
    freeBetMinOdd,
    handleQuickActions,
    autoCashOutOddPopupId,
  }) => {
    const freeBetMinOddChecker = (event, item) => {
      const freeBetMin = freeBetStore.activeFreeBet?.minOdd || freeBetMinOdd;
      if (autoCashOutOddPopupId === itemId && freeBetMin >= item) {
        notificationStore.setNotificationType(BetResponseCode.InvalidFreeBetMinOdd);
      } else {
        handleQuickActions(event, item);
      }
      setTimeout(() => {
        notificationStore.setNotificationType(null);
      }, 2000);
    };
    return (
      <div className='c-m-bets-item-popover' ref={settingRef}>
        <div className='c-m-bets-item-popover-row-group'>
          {data
            .map((item, index) => (
              <span
                key={index}
                className='c-m-bets-item-popover-row'
                onClick={(event) => freeBetMinOddChecker(event, item)}
              >
                {isAutoCashOut ? 'x' : ''}
                {item} {isBetAmount ? userInfoStore.currencySymbolOrCode : ''}
              </span>
            ))
            .reverse()}
        </div>
        <div
          className='c-m-bets-item-popover-btn-wrapper'
          onClick={() => {
            handleCancelAction(itemId);
          }}
        >
          <button className='c-m-bets-item-popover-btn' type='button'>
            <img alt='' src={buttonClose} className='c-m-bets-item-popover-btn-img' />
          </button>
        </div>
      </div>
    );
  }
);

export default QuickActionPopOver;
